import { ApiPagedRequest, ApiRequest } from 'app/common/types'
import { InstalledConnection } from 'app/connections/types'

import { Campaign } from './campaign'

export interface TreatmentsGetContent {
  id?: string[]
  connection?: string[]
}

export type TreatmentsGetRequest = ApiRequest<TreatmentsGetContent> & ApiPagedRequest

export interface TreatmentEntity {
  conversion: string
  id: string
  name: string
  relates_to: { campaign: Campaign }
  connection: string
}

export interface TreatmentsGetResponse {
  data: TreatmentEntity[]
}

export type Treatment = {
  campaign: Campaign
  id: string
  name: string
  connection: InstalledConnection | null
}

const mapToTreatment = (
  treatmentEntity: TreatmentEntity,
  connections: InstalledConnection[],
): Treatment => ({
  campaign: treatmentEntity.relates_to.campaign,
  id: treatmentEntity.id,
  name: treatmentEntity.name,
  connection: connections.find((conn) => conn.id === treatmentEntity.connection) ?? null,
})

export const mapToTreatments = (
  treatmentEntities: TreatmentEntity[],
  connections: InstalledConnection[],
): Treatment[] =>
  treatmentEntities.map((treatmentEntity) => mapToTreatment(treatmentEntity, connections))
